import api from "./api";

export type Periodicity =
    | "weekly"
    | "biweekly"
    | "monthly"
    | "bimonthly"
    | "quarterly"
    | "biannual"
    | "yearly";


export const PeriodicityTranslate = {
    weekly: "Semanal",
    biweekly: "Quinzenal",
    monthly: "Mensal",
    bimonthly: "Bimestral",
    quarterly: "Trimestral",
    biannual: "Semestral",
    yearly: "Anual",
};

export interface ServiceProps {
    IdSubscriptionService: number;
    Service: {
        Description: string;
    };
}

interface PlansResponse {
    IdSubscriptionDetail: number
    PlanName: string
    Description: string
    Value: number
    AllCompanies: boolean
    companiesList: [],
    GalaxPayId: number
    Periodicity: Periodicity
    subscriptionServiceList: ServiceProps[]
}


export interface RequestCreateSubscriptionProps {
    planId: number;
    customer: {
        type: "EMAIL_PASSWORD_USER" | "NEW_USER" | "GOOGLE_USER" | string;
        name: string;
        document: string;
        email: string;
        phone: string;
    };
    cardHash: string
    companyId: number
    professionalId: number
}

export const getPlans = (): Promise<PlansResponse[]> => {
    return api
        .get("checkout/")
        .then((response) => {
            const { data } = response;
            return data
        })
}

export const createSubscription = (data: RequestCreateSubscriptionProps): Promise<PlansResponse[]> => {
    return api
        .post("checkout/subscription", data)
        .then((response) => {
            const { data } = response;
            return data
        })
}

export interface TokenizeConfig {
  publicToken: string;
  isProduction: boolean;
}

export const getTokenizeConfig = (): Promise<TokenizeConfig> => {
  return api.get("checkout/tokenize-config").then((response) => response.data);
};